// pdf.js, cargado SOLO cuando se abre un PDF (04-11-2026): ni el chat ni la oficina lo descargan si nadie abre uno.
//
// Build «legacy» a propósito: la normal de pdf.js 6 usa funciones de JavaScript que aún no tienen todos los navegadores
// (Math.sumPrecise, Map.getOrInsertComputed) y en el Safari del iPad o en un Chrome de hace unos meses dejaría la página
// en blanco; la legacy trae sus apaños y pesa casi lo mismo (≈ 0,5 MB + 1,3 MB del worker, sin comprimir).
// El worker lo sirve Vite desde el mismo origen (`?url`): cumple la CSP `script-src 'self'` (deploy/Caddyfile), sin
// blob: ni eval (pdf.js 6 ya no compila fuentes con eval: CVE-2024-4367 no aplica).
// Las pruebas sustituyen este módulo entero (vi.mock): jsdom no tiene canvas.
import type { PDFDocumentProxy } from 'pdfjs-dist';

type Pdfjs = typeof import('pdfjs-dist');

let cargando: Promise<Pdfjs> | null = null;

function pdfjs(): Promise<Pdfjs> {
  cargando ??= Promise.all([import('pdfjs-dist/legacy/build/pdf.mjs'), import('pdfjs-dist/legacy/build/pdf.worker.min.mjs?url')])
    .then(([lib, worker]) => {
      lib.GlobalWorkerOptions.workerSrc = worker.default;
      return lib as unknown as Pdfjs;
    })
    .catch((err: unknown) => {
      cargando = null; // un fallo de red no se queda pegado: el siguiente intento vuelve a cargar
      throw err;
    });
  return cargando;
}

export type DocumentoPdf = PDFDocumentProxy;

/** Abre un PDF ya descargado. `destruir()` libera el worker y la memoria al cerrar el visor. */
export async function abrirPdf(datos: ArrayBuffer): Promise<{ doc: DocumentoPdf; destruir: () => void }> {
  const lib = await pdfjs();
  const tarea = lib.getDocument({ data: new Uint8Array(datos), verbosity: 0 });
  const doc = await tarea.promise;
  return { doc, destruir: () => void tarea.destroy() };
}
